import React from 'react';
import './PolicyMilitarismDescription.css';
import {
  POLICY_MILITARISM_UNIT_MELEE_BONUS_D10,
  POLICY_MILITARISM_UNIT_MELEE_BONUS_D12,
  POLICY_MILITARISM_UNIT_MELEE_BONUS_D20,
  POLICY_MILITARISM_UNIT_MELEE_BONUS_D6,
  POLICY_MILITARISM_UNIT_MELEE_BONUS_D8,
  POLICY_MILITARISM_UNIT_MELEE_BONUS_WITH_MILITARY_CAMP_D10,
  POLICY_MILITARISM_UNIT_MELEE_BONUS_WITH_MILITARY_CAMP_D12,
  POLICY_MILITARISM_UNIT_MELEE_BONUS_WITH_MILITARY_CAMP_D20,
  POLICY_MILITARISM_UNIT_MELEE_BONUS_WITH_MILITARY_CAMP_D6,
  POLICY_MILITARISM_UNIT_MELEE_BONUS_WITH_MILITARY_CAMP_D8,
} from "../../../../configs/policy/militarism";
import DescriptionValueWithIcon from "../../DescriptionValueWithIcon/DescriptionValueWithIcon";

const PolicyMilitarismDescription = () => {
  const damage = <img
    className={'policy-description-icon'}
    src={'/img/icons/damage.png'}
    alt={'Урон'}
    title={'Урон'}
  />;
  const melee = <img
    className={'policy-description-icon'}
    src={'/img/icons/barracks red.png'}
    alt={'Ближний бой'}
    title={'Ближний бой'}
  />;
  const meleeDamageValueAndIcon = <DescriptionValueWithIcon
    className={'policy-description-icon-margin-left-end'}
    value={damage}
    icon={melee}
  />

  const militaryCamp = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-left'}
    src={'/img/hexes/special buildings/military camp.1216e2cd.png'}
    alt={'Лагерь'}
    title={'Лагерь'}
  />;

  return (
    <>
      <div className={'policy-description_line'}>
        В ближнем бою {meleeDamageValueAndIcon}:
      </div>
      <div className={'policy-description_line'}>
        <img
          className={'policy-description-icon-unit policy-description-icon-unit-margin-right'}
          src={'/img/icons/unit d6 friend.png'}
          alt={'Отряд Пехота (макс. размер 6)'}
          title={'Отряд Пехота (макс. размер 6)'}
        />
        <span className={'text-war'}>
          +{POLICY_MILITARISM_UNIT_MELEE_BONUS_D6}
        </span>
        ,
        <img
          className={'policy-description-icon-unit policy-description-icon-unit-margin-right-left'}
          src={'/img/icons/unit d10 friend.png'}
          alt={'Отряд Тяжелая Пехота (макс. размер 10)'}
          title={'Отряд Тяжелая Пехота (макс. размер 10)'}
        />
        <span className={'text-war'}>
          +{POLICY_MILITARISM_UNIT_MELEE_BONUS_D10}
        </span>
        ,
        <img
          className={'policy-description-icon-unit policy-description-icon-unit-margin-right-left'}
          src={'/img/icons/unit d20 friend.png'}
          alt={'Отряд Элитная Пехота (макс. размер 20)'}
          title={'Отряд Элитная Пехота (макс. размер 20)'}
        />
        <span className={'text-war'}>
          +{POLICY_MILITARISM_UNIT_MELEE_BONUS_D20}
        </span>
        ,
      </div>
      <div className={'policy-description_line'}>
        <img
          className={'policy-description-icon-unit policy-description-icon-unit-margin-right-left'}
          src={'/img/icons/unit d8 friend.png'}
          alt={'Отряд Легкая Кавалерия (макс. размер 8)'}
          title={'Отряд Легкая Кавалерия (макс. размер 8)'}
        />
        <span className={'text-war'}>
          +{POLICY_MILITARISM_UNIT_MELEE_BONUS_D8}
        </span>
        ,
        <img
          className={'policy-description-icon-unit policy-description-icon-unit-margin-right-left'}
          src={'/img/icons/unit d12 friend.png'}
          alt={'Отряд Тяжёлая Кавалерия (макс. размер 12)'}
          title={'Отряд Тяжёлая Кавалерия (макс. размер 12)'}
        />
        <span className={'text-war'}>
          +{POLICY_MILITARISM_UNIT_MELEE_BONUS_D12}
        </span>
        .
      </div>

      <div className={'policy-description_line policy-description_line-margin-top'}>
        Если у игрока есть {militaryCamp} , то {meleeDamageValueAndIcon}:
      </div>
      <div className={'policy-description_line'}>
        <img
          className={'policy-description-icon-unit policy-description-icon-unit-margin-right-left'}
          src={'/img/icons/unit d6 friend.png'}
          alt={'Отряд Пехота (макс. размер 6)'}
          title={'Отряд Пехота (макс. размер 6)'}
        />
        <span className={'text-war'}>
          +{POLICY_MILITARISM_UNIT_MELEE_BONUS_WITH_MILITARY_CAMP_D6}
        </span>
        ,
        <img
          className={'policy-description-icon-unit policy-description-icon-unit-margin-right-left'}
          src={'/img/icons/unit d10 friend.png'}
          alt={'Отряд Тяжелая Пехота (макс. размер 10)'}
          title={'Отряд Тяжелая Пехота (макс. размер 10)'}
        />
        <span className={'text-war'}>
          +{POLICY_MILITARISM_UNIT_MELEE_BONUS_WITH_MILITARY_CAMP_D10}
        </span>
        ,
        <img
          className={'policy-description-icon-unit policy-description-icon-unit-margin-right-left'}
          src={'/img/icons/unit d20 friend.png'}
          alt={'Отряд Элитная Пехота (макс. размер 20)'}
          title={'Отряд Элитная Пехота (макс. размер 20)'}
        />
        <span className={'text-war'}>
          +{POLICY_MILITARISM_UNIT_MELEE_BONUS_WITH_MILITARY_CAMP_D20}
        </span>
        ,
      </div>
      <div className={'policy-description_line'}>
        <img
          className={'policy-description-icon-unit policy-description-icon-unit-margin-right-left'}
          src={'/img/icons/unit d8 friend.png'}
          alt={'Отряд Легкая Кавалерия (макс. размер 8)'}
          title={'Отряд Легкая Кавалерия (макс. размер 8)'}
        />
        <span className={'text-war'}>
          +{POLICY_MILITARISM_UNIT_MELEE_BONUS_WITH_MILITARY_CAMP_D8}
        </span>
        ,
        <img
          className={'policy-description-icon-unit policy-description-icon-unit-margin-right-left'}
          src={'/img/icons/unit d12 friend.png'}
          alt={'Отряд Тяжёлая Кавалерия (макс. размер 12)'}
          title={'Отряд Тяжёлая Кавалерия (макс. размер 12)'}
        />
        <span className={'text-war'}>
          +{POLICY_MILITARISM_UNIT_MELEE_BONUS_WITH_MILITARY_CAMP_D12}
        </span>
        .
      </div>
    </>
  );
};

export default PolicyMilitarismDescription;
